export const SET_ICP_DETAILS = "SET_ICP_DETAILS";
export const UNSET_ICP_DETAILS = "UNSET_ICP_DETAILS";
